<template>
  <el-container>
    <el-header style="height: 70px;background-color: #FFFFFF">
      <div class="header-info">
        <img class="header-logo" src="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/logo-s.png">
        <a class="company-name">广东良方药业有限公司</a>
        <div class="info-navi">
          <ul>
            <li>
              <el-link class="navi-link" href="/hy-mic-sy/home" :underline="false" style="color: #0270FF">首页</el-link>
            </li>
            <li>
              <el-link class="navi-link" href="/hy-mic-sy/news" :underline="false">行业资讯</el-link>
            </li>
            <li>
              <el-link class="navi-link" href="/hy-mic-sy/about" :underline="false">关于我们</el-link>
            </li>
            <li>
              <el-link class="navi-link" href="/hy-mic-sy/contactUs" :underline="false">联系我们</el-link>
            </li>
          </ul>
        </div>
      </div>
<!--        <el-row style="text-align: center;width: 50%;margin: 0 auto;">-->
<!--          <el-col :span="8">-->
<!--            <div class="grid-content bg-purple">-->
<!--              <el-image-->
<!--                style="width: 130px; height: 120px"-->
<!--                :src="url"-->
<!--                :preview-src-list="srcList">-->
<!--              </el-image>-->
<!--            </div>-->
<!--          </el-col>-->
<!--          <el-col :span="8">-->
<!--            <div class="grid-content bg-purple-light">-->
<!--              <el-image-->
<!--                style="width: 130px; height: 120px"-->
<!--                :src="url2"-->
<!--                :preview-src-list="srcList2">-->
<!--              </el-image>-->
<!--            </div>-->
<!--          </el-col>-->
<!--          <el-col :span="8">-->
<!--            <div class="grid-content bg-purple">-->
<!--              <el-image-->
<!--                style="width: 130px; height: 120px"-->
<!--                :src="url3"-->
<!--                :preview-src-list="srcList3">-->
<!--              </el-image>-->
<!--            </div>-->
<!--          </el-col>-->
<!--        </el-row>-->
    </el-header>
    <el-main style="margin: 0 auto;padding: 0;width: 1200px; padding-top: 10px;margin-top: 10px">
      <div class="main-banner">
        <el-carousel :interval="4000" height="400px" indicator-position="none">
          <el-carousel-item v-for="item in banners" :key="item.name" style="background-color: #FFFFFF">
            <el-image :src='item.url'></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!--      <div class="order-flow">-->
      <!--          <img class="flow-one" src="../../../static/images/orderFlow/flow-one.jpg">-->
      <!--          <img class="flow-one-detail" src="../../../static/images/orderFlow/flow-one-detail.png">-->
      <!--      </div>-->
      <!--      <div class="second-banner">-->
      <!--        <el-carousel :interval="4000" height="350px" indicator-position="none">-->
      <!--          <el-carousel-item v-for="item in itemBanners" :key="item.name" style="background-color: #FFFFFF">-->
      <!--            <el-image :src='item.url'></el-image>-->
      <!--          </el-carousel-item>-->
      <!--        </el-carousel>-->
      <!--      </div>-->
      <!--      <div class="industry-information">-->
      <!--        <p style="background-color: #82c6fe;border-radius: 24px 24px 0px 0px;color: whitesmoke">行业资讯</p>-->
      <!--        <p style="line-height: 40px">-->
      <!--          <el-link style="color: #0C78D3" title="良医荣获年度中国医疗十大创新服务奖" target="_blank" href="https://mp.weixin.qq.com/s?__biz=MzI5NDk5NzUwMg==&mid=2247486838&idx=1&sn=bfadfdba80bbf61ba3dae3ff68e66a50&chksm=ec5b11e7db2c98f184b59b8564b83f413c8b09152664f3c0a8e2992cb26f8fdb3ecb727e80cd&token=2131012173&lang=zh_CN#rd">-->
      <!--            1. 良医荣获年度中国医疗十大创新服务奖-->
      <!--          </el-link>-->
      <!--          <el-link style="color: #0C78D3" title="广东省诊所基层医疗机构大数据" target="_blank" href="https://mp.weixin.qq.com/s/vml2n35YQgDwfwtK4fm4YQ">-->
      <!--            2. 广东省诊所基层医疗机构大数据-->
      <!--          </el-link>-->
      <!--          <el-link style="color: #0C78D3" title="劲增！！全国正规诊所从2010年的17.4万个增长到2017年的23万个" target="_blank" href="https://mp.weixin.qq.com/s?__biz=MzI5NDk5NzUwMg==&mid=2247483669&idx=1&sn=adb4b2cee915e6b4733c050e66542970&chksm=ec5b1d84db2c94924067e07b1ffe34b0bd05a739e99b1bb08092d5d57cba008f99431906005a&token=1073245439&lang=zh_CN#rd">-->
      <!--            3. 劲增！！全国正规诊所从2010年的17.4万...-->
      <!--          </el-link>-->
      <!--          <el-link style="color: #0C78D3" target="_blank" href="https://mp.weixin.qq.com/s/tjzbTPS7-YeZDmXccp-XhQ">-->
      <!--            4. 康朗诊所：让顾客健康是我最大的心愿-->
      <!--          </el-link>-->
      <!--          <el-link style="color: #0C78D3" target="_blank" href="https://mp.weixin.qq.com/s/28jym0d5l0SKoSq3f8zKhw">-->
      <!--            5. 康华西医门诊：主推中医靠疗效收获更多粉丝-->
      <!--          </el-link>-->
      <!--          <el-link style="color: #0C78D3" title="卫健委发布最新数据：全国诊所增加19192个！乡镇卫生院用药超过857亿！" target="_blank" href="https://mp.weixin.qq.com/s?__biz=MzI5NDk5NzUwMg==&mid=2247487308&idx=1&sn=5fca3a351293b6fe5c44a0c1a3b21596&chksm=ec5b13dddb2c9acbb3f2c9d55944cc62dbd741935afdf1738f7fb93f771b6131e28670ef4831&token=958382610&lang=zh_CN#rd">-->
      <!--            6. 卫健委发布最新数据：全国诊所增加19192个...-->
      <!--          </el-link>-->
      <!--          <el-link style="color: #0C78D3" title="权威发布】2020年诊所突破26万家，年新增诊所1.8万余家" target="_blank" href="https://mp.weixin.qq.com/s/kBV-Ck8uHoD16jN_GlHCrQ">-->
      <!--            7. 【权威发布】2020年诊所突破26万家，年新...-->
      <!--          </el-link>-->
      <!--        </p>-->
      <!--      </div>-->
      <div class="product">
        <div class="product-title">
          <img src="../../../static/images/home/flow/product.png">
        </div>
        <div class="product-list">
          <div class="product-detail" @click="toProduct(1)">
            <div class="product-img">
              <img src="http://lyly360.oss-cn-shenzhen.aliyuncs.com/file18031561622515442.jpg">
            </div>
            <div class="product-name">
              清热祛湿颗粒
            </div>
          </div>
          <div class="product-detail" @click="toProduct(2)">
            <div class="product-img">
              <img src="http://lyly360.oss-cn-shenzhen.aliyuncs.com/filechc5hKxRZQ.png-ly.jpg">
            </div>
            <div class="product-name">
              小柴胡颗粒
            </div>
          </div>
          <div class="product-detail" @click="toProduct(3)">
            <div class="product-img">
              <img src="http://lyly360.oss-cn-shenzhen.aliyuncs.com/file4TCtkMYHBH.jpg">
            </div>
            <div class="product-name">
              京制牛黄解毒片
            </div>
          </div>
          <div class="product-detail" @click="toProduct(4)">
            <div class="product-img">
              <img src="http://lyly360.oss-cn-shenzhen.aliyuncs.com/filef68Q6SFzEW.jpg-ly.jpg">
            </div>
            <div class="product-name">
              清开灵口服液
            </div>
          </div>
          <div class="product-detail" @click="toProduct(5)">
            <div class="product-img">
              <img src="http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileaJjGRdPPAE.jpg">
            </div>
            <div class="product-name">
              感冒灵颗粒
            </div>
          </div>
          <div class="product-detail" @click="toProduct(6)">
            <div class="product-img">
              <img src="http://lyly360.oss-cn-shenzhen.aliyuncs.com/file86881561623365639.jpg">
            </div>
            <div class="product-name">
              小儿七星茶颗粒
            </div>
          </div>
          <div class="product-detail" @click="toProduct(7)">
            <div class="product-img">
              <img src="http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileEXnQAmSiaP.jpg">
            </div>
            <div class="product-name">
              蛇胆川贝液
            </div>
          </div>
          <div class="product-detail" @click="toProduct(8)">
            <div class="product-img">
              <img src="http://lyly360.oss-cn-shenzhen.aliyuncs.com/file50051561622581425.jpg">
            </div>
            <div class="product-name">
              壮腰健肾丸
            </div>
          </div>
          <div class="product-detail" @click="toProduct(9)">
            <div class="product-img">
              <img src="http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileAwYfTNpYX6.jpg">
            </div>
            <div class="product-name">
              强力枇杷露（低糖）
            </div>
          </div>
          <div class="product-detail" @click="toProduct(10)">
            <div class="product-img">
              <img src="http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileN58jz3FTYz.jpg">
            </div>
            <div class="product-name">
              消炎镇痛膏
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer style="height: 70px;padding-top: 40px">
      <div class="footer-info">
        <p style="line-height: 25px">
          版权所有©广东良方药业有限公司 |
          <a href="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/xinxizheng.jpg" target="_blank">
            互联网药品信息服务资格证书编号(粤)-经营性-2020-0099
          </a> <br>
          ICP主体备案号：
          <a href="https://beian.miit.gov.cn/" target="_blank">
            粤ICP备2022011696号-1
          </a><br>
          <a href="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/yinyezhizhao.jpg" target="_blank">营业执照副本</a>
        </p>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      activeName: 'first',
      banners: [
        {
          name: 'banner1',
          url: 'https://liangyituan.oss-cn-shenzhen.aliyuncs.com/clinic/5fae2a8076ebe5602a768e722440839.jpg'
        },
        {
          name: 'banner2',
          url: 'https://liangyituan.oss-cn-shenzhen.aliyuncs.com/clinic/19e47808a07345b4451554d8a5bf011.jpg'
        }
      ],
      itemBanners: [
        {name: 'banner1', url: 'http://lf.liangyt.cn/hy-mic-sy/img/swiperimg1.07be7ae5.jpg'},
        {name: 'banner2', url: 'http://lf.liangyt.cn/hy-mic-sy/img/swiperimg0.33571a82.jpg'},
        {name: 'banner3', url: 'http://lf.liangyt.cn/hy-mic-sy/img/swiperimg2.bd9ef58a.jpg'}
      ],
      url: 'https://liangyituan.oss-cn-shenzhen.aliyuncs.com/clinic/20231019164659.jpg',
      srcList: ['https://liangyituan.oss-cn-shenzhen.aliyuncs.com/clinic/20231019164659.jpg'],
      url2: 'https://liangyituan.oss-cn-shenzhen.aliyuncs.com/clinic/86a6e65c59d2cd7b9481b4cb9b2b71d.png',
      srcList2: ['https://liangyituan.oss-cn-shenzhen.aliyuncs.com/clinic/86a6e65c59d2cd7b9481b4cb9b2b71d.png'],
      url3: 'https://liangyituan.oss-cn-shenzhen.aliyuncs.com/clinic/0ff0aa0b2af166f931fc51d1a46c48e.jpg',
      srcList3: ['https://liangyituan.oss-cn-shenzhen.aliyuncs.com/clinic/0ff0aa0b2af166f931fc51d1a46c48e.jpg']
    }
  },
  methods: {
    toProduct(id) {
      this.$router.push({
        path: '/productDetail',
        query: {
          id: id
        }
      })
    }
  }
}
</script>

<style>

.product-img img {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

.product-name {
  font-size: 14px;
  font-weight: 600;
  margin-top: 5px;
}

.product-img {
  width: 180px;
  height: 180px;
}

.product-detail {
  width: 210px;
  height: 225px;
  padding-top: 6px;
  padding-left: 15px;
  padding-right: 15px;
  float: left;
  margin-left: 25px;
  margin-top: 10px;
}

.product-list {
  height: 480px;
  margin-top: 20px;

}

.product {
  margin-top: 40px;
  clear: both;
}

.industry-information {
  width: 480px;
  height: 350px;
  background-color: #FFFFFF;
  margin-top: 20px;
  margin-left: 10px;
  float: left;
  border: 1px solid #82c6fe;
  border-radius: 24px;
}

.industry-information p {
  font-size: 24px;
  font-weight: 400;
}

.second-banner {
  width: 700px;
  float: left;
  margin-top: 20px;
}

.second-banner img {
  width: 700px;
  height: 350px;
}

.footer-info {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
}

.el-link {
  font-size: 18px;
}

ul {
  display: flex;
  list-style: none;
  padding: 0;
  line-height: 40px;
  height: 70px;
  float: right;
  margin-right: 50px;
}

li {
  list-style: none;
  margin: 0;
  padding: 0;
  margin-left: 40px;
  line-height: 70px;
}

.info-navi {
  float: right;
  width: 750px;
  height: 70px;
  text-align: right;
}

.main-banner {
}

.el-header, .el-footer {
  color: #333;
  text-align: left;
  line-height: 70px;
  height: 70px;
}

.header-info {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.header-logo {
  width: 80px;
  height: 65px;
  float: left;
}

.header-info .company-name {
  font-size: 24px;
  font-weight: bold;
  margin-left: 10px;
  float: left;
}
</style>
<style scoped>

</style>
